import { FC, MutableRefObject, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { LayoutProps, layout, SpaceProps } from 'styled-system';
import { HStack, Text } from '@bpba/ui-components';
import { ErrorData } from './ErrorData';
import { ERROR_CODE_TEXT } from '../../constants/data';
import { StyledErrorIcon } from './StyledErrorIcon';

const ERROR_ICON_SIZE = 28;

type Props = {
  show?: boolean;
  errorMessage?: ErrorData;
} & SpaceProps;

export const ErrorMessageContainer: FC<Props> = ({ show, errorMessage, ...otherProps }) => {
  const ref: MutableRefObject<HTMLParagraphElement | null> = useRef(null);

  /** Accesibilidad: se hace foco en el mensaje cuando se
   *  activa este componente de error.
   */
  useEffect(() => {
    if (show) ref?.current?.focus();
  }, [show]);

  if (!show || !errorMessage || (!errorMessage.message && !errorMessage.code)) return <></>;

  const reason = errorMessage.message ?? '';
  const errorCode = errorMessage.code ? ` (${ERROR_CODE_TEXT} ${errorMessage.code})` : '';

  const msg = `${reason}.`;
  const msg_detailed = `${reason}${errorCode}.`;

  console.log(msg_detailed);

  return (
    <HStack color={'red'} alignItems="center" paddingY={'16px'} borderRadius={4} marginTop="16px" {...otherProps}>
      <StyledErrorIcon size={ERROR_ICON_SIZE} />
      <StyledExternalText
        textAlign={'start'}
        padding={'0px 0px 0px 8px !important'}
        fontSize={12}
        dangerouslySetInnerHTML={{ __html: msg }}
        width={'fit-content'}
        tabIndex={0}
        ref={ref}
      />
    </HStack>
  );
};

const StyledExternalText = styled(Text)<LayoutProps>(layout, {
  a: {
    color: 'primary.0',
  },
});
